import React from 'react';
import Icon from '../../../components/AppIcon';

const BulkActionsBar = ({ selectedCount, onBulkAction, onClearSelection }) => {
  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 elevation-sm">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center">
            <span className="text-xs font-bold text-primary-foreground">{selectedCount}</span>
          </div>
          <p className="text-sm font-medium text-foreground font-body">
            {selectedCount} client{selectedCount > 1 ? 's' : ''} selected
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <button
            onClick={() => onBulkAction('activate')}
            className="flex items-center gap-2 px-3 py-1.5 bg-success text-white rounded-md hover:bg-success/90 transition-smooth text-sm font-medium font-body"
          >
            <Icon name="CheckCircle" size={14} />
            Activate
          </button>
          <button
            onClick={() => onBulkAction('suspend')}
            className="flex items-center gap-2 px-3 py-1.5 bg-warning text-white rounded-md hover:bg-warning/90 transition-smooth text-sm font-medium font-body"
          >
            <Icon name="AlertCircle" size={14} />
            Suspend
          </button>
          <button
            onClick={() => onBulkAction('changePlan')}
            className="flex items-center gap-2 px-3 py-1.5 bg-info text-white rounded-md hover:bg-info/90 transition-smooth text-sm font-medium font-body"
          >
            <Icon name="RefreshCw" size={14} />
            Change Plan
          </button>
          <button
            onClick={() => onBulkAction('sendEmail')}
            className="flex items-center gap-2 px-3 py-1.5 bg-card border border-border text-foreground rounded-md hover:bg-muted transition-smooth text-sm font-medium font-body"
          >
            <Icon name="Mail" size={14} />
            Send Email
          </button>
          <button
            onClick={onClearSelection}
            className="flex items-center gap-2 px-3 py-1.5 bg-card border border-border text-muted-foreground rounded-md hover:bg-muted transition-smooth text-sm font-medium font-body"
          >
            <Icon name="X" size={14} />
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;